// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-c9OS","largestCol":"styles_largestCol__1TQ34","smallestCol":"styles_smallestCol__2nPEB"};